import { t } from "i18next";
import { Helmet } from "react-helmet-async";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import "../styles/Landing.scss";
import { Trans } from "react-i18next";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import ReactPlayer from "react-player";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

function Landing() {
    const mobileVideoOptions = useMemo(() => ['/videos/feetapp_paper_boy.mov', '/videos/feetapp_paper_girl.mov'], []);
    const scannerVideoOptions = useMemo(() => ['/videos/feetapp_scaner_boy.mov', '/videos/feetapp_scaner_girl.mov'], []);

    const getRandomVideo = useCallback((options) => {
        const randomIndex = Math.floor(Math.random() * options.length);
        return options[randomIndex];
    }, []);

    const mobileVideoUrl = useMemo(() => getRandomVideo(mobileVideoOptions), [getRandomVideo, mobileVideoOptions]);
    const scannerVideoUrl = useMemo(() => getRandomVideo(scannerVideoOptions), [getRandomVideo, scannerVideoOptions]);

    const [isLastSectionVisible, setIsLastSectionVisible] = useState(false);
    const lastSectionRef = useRef(null);

    useEffect(() => {
        const observerRef = lastSectionRef.current ? lastSectionRef.current : null;

        const observer = new IntersectionObserver(
            ([entry]) => setIsLastSectionVisible(entry.isIntersecting),
            { threshold: 0.5 }
        );

        if (observerRef) {
            observer.observe(observerRef);
        }

        return () => {
            if (observerRef) {
                observer.unobserve(observerRef); // Clean up the observer when the component unmounts
            }
        }
    }, [lastSectionRef]);

    return (
        <>
            <Helmet>
                <title>{t("landingPageTitle")}</title>
            </Helmet>

            <Header />

            <div className="landing-scroll-container">
                {/* Section 1: Make a measurement */}
                <section className="landing-section bg-light" id="make-measurement">
                    <Container>
                        <h1 className="display-4"><Trans>landing1MakeMeasurement</Trans></h1>
                        <Row>
                            <Col md={6}>
                                <h4><Trans>landing1MakeMeasurementMobile</Trans></h4>
                                <ReactPlayer controls width={'100%'} height={'100%'} fallback={<Spinner animation="border" />} url={mobileVideoUrl} />
                            </Col>
                            <Col md={6}>
                                <h4><Trans>landing1MakeMeasurementScanner</Trans></h4>
                                <ReactPlayer controls width={'100%'} height={'100%'} fallback={<Spinner animation="border" />} url={scannerVideoUrl} />
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Section 2: Auto Fitting */}
                <section className="landing-section bg-white text-center d-flex flex-column justify-content-center" id="auto-fitting">
                    <Container>
                        <h1 className="display-4"><Trans>landing2AutoFitting</Trans></h1>
                        <p className="lead mb-4"><Trans>landing2AutoFittingDescription</Trans></p>
                        <Button variant="primary" size="lg" href="/catalog"><Trans>landing2AutoFittingButton</Trans></Button>
                    </Container>
                </section>

                {/* Section 3: Order Online */}
                <section className="landing-section bg-light text-center d-flex flex-column justify-content-center" id="order-online">
                    <Container>
                        <h1 className="display-4"><Trans>landing3OrderOnline</Trans></h1>
                        <p className="lead mb-4"><Trans>landing3OrderOnlineDescription</Trans></p>
                        <Button variant="success" size="lg" href="/cart"><Trans>landing3OrderOnlineButton</Trans></Button>
                    </Container>
                </section>

                {/* Leaflet Link */}
                <section className="landing-section bg-dark text-white text-center d-flex flex-column justify-content-center" id="leaflet-link" ref={lastSectionRef}>
                    <Container>
                        <h2 className="mb-4"><Trans>landing4Leaflet</Trans></h2>
                        <a
                            href="/promo/FeetApp_leaflet.pdf"
                            className="btn btn-outline-light btn-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Trans>landing4LeafletButton</Trans>
                        </a>
                    </Container>
                </section>

                {/* Scroll Hint */}
                {!isLastSectionVisible && (
                    <div className="scroll-hint">
                        <span className="scroll-arrow">&#x25BC;</span> {/* Downward chevron */}
                    </div>
                )}
            </div>

            {isLastSectionVisible && <Footer />}
        </>
    );
}

export default Landing;
